import PaymentMethodFactory from './payment_methods/PaymentMethodFactory';

export default class PaymentPage {
  constructor(optionsForm) {
    this.optionsForm = optionsForm;
  }

  async orchestratePaymentOptions() {
    const radioButtons = this.optionsForm.find('input[type="radio"]');

    this.availablePaymentMethods = (
      await Promise.all(
        radioButtons.map(async (_index, element) => this.handlePaymentMethodAvailability(element))
      )
    ).filter(paymentMethod => !!paymentMethod);

    if(this.availablePaymentMethods.length === 1) {
      this.availablePaymentMethods[0].showMe();
    } else {
      $('.payment-options').removeClass('hidden');
    }
  }

  async handlePaymentMethodAvailability(element) {
    const payment_method = PaymentMethodFactory.for(element)
    if (await payment_method.isAvailable()) {
      payment_method.showOption();
      payment_method.bindFormMethods(this);

      return payment_method;
    }
  }

  showOnly(selectedPaymentMethod) {
    $('#none-form').addClass('hidden');
    this.availablePaymentMethods.forEach((paymentMethod) => {
      if (paymentMethod !== selectedPaymentMethod) paymentMethod.hideForm();
    });
    selectedPaymentMethod.showForm();
  }

  disable() {
    this.availablePaymentMethods.forEach(paymentMethod => {
      paymentMethod.disable();
    })
  }

  enable() {
    this.availablePaymentMethods.forEach(paymentMethod => {
      paymentMethod.enable();
    })
  }
}
